import { useCallback, useEffect, useState } from 'react';
import { TimecodeFormat } from '../utils/format-time';

const STORAGE_KEY = 'timeline-timecode-format';
const DEFAULT: TimecodeFormat = 'mm-ss-tenths';
const VALID: TimecodeFormat[] = ['mm-ss', 'mm-ss-tenths', 'mm-ss-frames', 'mm-ss-cents'];

const readStored = (): TimecodeFormat => {
  if (typeof window === 'undefined') return DEFAULT;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  return (VALID as string[]).includes(raw ?? '') ? (raw as TimecodeFormat) : DEFAULT;
};

/**
 * User preference for the playhead time display.
 * Persisted in localStorage so it survives reloads.
 */
export const useTimecodeFormat = (): [TimecodeFormat, (next: TimecodeFormat) => void] => {
  const [format, setFormat] = useState<TimecodeFormat>(readStored);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(STORAGE_KEY, format);
  }, [format]);

  const update = useCallback((next: TimecodeFormat) => setFormat(next), []);

  return [format, update];
};
